<script>
import TwContainerFullWidth from '../../../components/generic/tw-container-full-width.vue'
import { useFundraiserInvitePublicStore } from '@/stores/fundraiserInvitePublic.js'
import FundraiserJoinPage from '@/pages/fundraisers/public/FundraiserJoinPage.vue'
import NotFound from '@/pages/NotFound.vue'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useAuthStore } from '@/stores/auth.js'

export default {
  name: 'FundraiserInviteAcceptPagePublic',
  components: { TwLoadingSpinner, NotFound, FundraiserJoinPage, TwContainerFullWidth },
  mixins:[fetchDataMixin],
  props: {
    fundraiserInviteUuid: {
      type: String,
      required: true,
    }
  },
  computed: {
    fundraiserInvite() {
      return useFundraiserInvitePublicStore().getItemByUuId(this.fundraiserInviteUuid)
    }
  },
  mounted() {
    this.fetchFundraiserInvite()
  },
  methods: {
    async fetchFundraiserInvite() {
      await this.fetchDataCallBack(async () => useFundraiserInvitePublicStore().fetchItemById(this.fundraiserInviteUuid))
      if(this.fundraiserInvite) {
        // attempt autologin assuming the user is not logged in
        //await useAuthStore().loginViaToken(this.fundraiserInvite.token)
      }
    }
  }
}
</script>

<template>
  <tw-container-full-width>
    <fundraiser-join-page v-if="fundraiserInvite" :fundraiser-id="fundraiserInvite.fundraiser_id" :fundraiser-invite="fundraiserInvite" />
    <not-found v-else-if="!fundraiserInvite && !Loading" />
    <tw-loading-spinner v-else />
  </tw-container-full-width>
</template>

<style scoped>

</style>
